import React from 'react';

import { FilterAlt as FilterIcon } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';

import { Popover } from 'src/components/common';
import { useInboxFilter } from 'src/hooks/inboxItem';

import { InboxFilterForm } from './InboxFilterForm';
import { isInboxFormFilterEmpty } from './utils';

export const InboxFilterButton: React.FC = () => {
  const { filterFormValues } = useInboxFilter();
  const isInboxFilterEmpty = React.useMemo(
    () => isInboxFormFilterEmpty(filterFormValues),
    [filterFormValues],
  );

  const renderFilterForm = React.useCallback(({ onClose }: { onClose: () => void }) => {
    return <InboxFilterForm onClose={onClose} />;
  }, []);

  return (
    <Popover
      target={
        <IconButton
          sx={{ color: theme => theme.palette.action.active }}
          data-e2e-element="inbox-filter-button"
        >
          <Badge
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            variant="dot"
            color="primary"
            invisible={isInboxFilterEmpty}
          >
            <FilterIcon />
          </Badge>
        </IconButton>
      }
      content={renderFilterForm}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    />
  );
};
